<template>
  <div class="loadMore">
    <a v-if="!paginationComplete" href="#!" class="button" @click.prevent="loadMore">Load More</a>
  </div>
</template>
<script>
import axios from "../config/axios";
import Masonry from "masonry-layout";

export default {
	props: {
		url: {
			type: String,
			default: ''
		},
		queryString:{
			type: String,
			default: ''
		},
		itemsPerPage: {
			type: Number,
			default: 0
		},
		totalItems: {
			type: Number,
			default: 0
		},
		containerSelector: {
			type: String,
			default: ''
		},
		itemSelector: {
			type: String,
			default: ''
		},
		useMasonry: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			count: 0,
			nextPage: 2,
			masonryGrid: null,
		};
	},
	computed: {
		paginationComplete: function () {
			return this.count >= this.totalItems;
		},
	},
	mounted: function () {
		this.count = this.itemsPerPage;
		if (this.useMasonry) {
			this.masonryGrid = new Masonry(this.containerSelector, {
				itemSelector: this.itemSelector,
				horizontalOrder: true,
			});
		}
	},
	methods: {
		loadMore: async function () {
			if (this.count < this.totalItems) {
				
				let nextUrl = this.url.at(-1) !== "/" ?
					this.url + "/p" + this.nextPage :
					this.url + "p" + this.nextPage;
				
				if(this.queryString !== '') {
					nextUrl += '?' + this.queryString;
				}
				const response = await axios.get(nextUrl);
				if (typeof response !== "undefined") {
					this.appendArticles(response);
				}
				this.nextPage++;
				this.count += this.itemsPerPage;
			}
		},
		appendArticles: function (response) {
			const container = document.querySelector(this.containerSelector);
			const temp = document.createElement("div");
			temp.innerHTML = response.data;

			while (temp.hasChildNodes()) {
				let elem = temp.removeChild(temp.firstChild);
				container.appendChild(elem);

				if (this.useMasonry) {
					this.masonryGrid.appended(elem);
				}
			}

			if (this.useMasonry) {
				this.masonryGrid.layout();
			}
		},
	},
};
</script>
